import React from 'react'

import LiveSelect from 'live/components/forms/ui/select'

type RigStateSelectorProps = {
    value: string[]
    onChange: (event: { target: { value: string[] } }) => void
    disabled: boolean
    state: ConditionsEditorState
    outputs: RigStateOutputs
}

const RigStateSelector = ({ disabled, onChange, outputs, value }: RigStateSelectorProps): React.ReactElement => (
    <LiveSelect
        noFormGroup
        multi={true}
        searchable={false}
        clearable={false}
        disabled={disabled}
        placeholder="Select rig state..."
        options={outputs.map(o => ({ label: o.overrideName || o.name, title: o.overrideName || o.name, value: o.id }))}
        onChange={(_, values) => {
            onChange({ target: { value: values.map(v => v.value) } })
        }}
        value={value}
    />
)

export default RigStateSelector
